import { PancakeStack } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { PageHeader } from './PageHeader';
import { SwitchBillingPlanTable } from './SwitchBillingPlanTable';

import { FullPageLoader } from '../../../Shared/Components/FullPageLoader';
import urlBuilder from '../../../Shared/url-builder';
import FlowLayout from '../../BettermentForAdvisors/FlowLayout';

export const SwitchBillingPlan = () => {
  const householdId = useRequiredParam('householdId');
  const { enabled, loading } = useFeatureFlag({
    splitName: 'retail.b4a_switch_billing_plan_react_q1_2026_enabled',
    context: 'SwitchBillingPlan',
  });

  if (loading) {
    return <FullPageLoader />;
  }

  if (!enabled) {
    window.location.reload();
    return null;
  }

  return (
    <FlowLayout>
      <PageHeader
        title="Switch Billing Plan"
        exitToPath={urlBuilder.getHouseholdsSettingsPage.absolute({ householdId })}
      />
      <PancakeStack.Main css={{ px: '120px' }}>
        <SwitchBillingPlanTable />
      </PancakeStack.Main>
    </FlowLayout>
  );
};
